(function() {
  function updateHamburger() {
    const hamburger = document.querySelector('.header__icon--menu');
    if (!hamburger) return;
    const svg = hamburger.querySelector('svg');
    if (!svg) return;
    if (window.scrollY > 80) {
      svg.style.setProperty('color', '#2D2320', 'important');
      svg.style.setProperty('fill', 'none', 'important');
    } else {
      svg.style.setProperty('color', '#ffffff', 'important');
      svg.style.setProperty('fill', 'none', 'important');
    }
  }

  window.addEventListener('scroll', updateHamburger, { passive: true });
  window.addEventListener('load', updateHamburger);
  document.addEventListener('DOMContentLoaded', updateHamburger);
  setTimeout(updateHamburger, 500);
})();